// PaymentController
app.controller('PaymentController', ['$scope', 'sessionService', 'WdHttpService', '$routeParams', 'config', '$timeout', 'analyticsService', '$interval',
    function($scope, sessionService, WdHttpService, $routeParams, config, $timeout, analyticsService, $interval) {

        // Init 
        $scope.init = async function() {
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            await $scope.fetchAdviserSiteDetails();

            $scope.paymentWarningLoader = false; //loader icon check
            $scope.isValueReturn = true; // Flag to check 
            $scope.thresholdValue = 8; // interval threshold value for 2 min
            var orderId = $routeParams.orderId;
            var paymentMode = $routeParams.mode ? $routeParams.mode.toUpperCase() : undefined;
            $scope.showPageLoader();
            if (orderId && (paymentMode == 'PAYTM' || paymentMode == undefined)) {
                $scope.referrenceId = orderId;

                await WdHttpService._payment_details({ 'orderId': orderId })
                    .then(async response => {
                        $scope.status = response.data.result;
                        var eventData = {
                            'fundName': response.data.fund_name.toLowerCase()
                        };
                        if ($scope.status == 'TXN_SUCCESS') {
                            $scope.showPageLoader();
                            var user_profile = await WdHttpService._cognito_profile(false);
                            $scope.brokerName = getProfileValueFor('custom:brokerName1', user_profile);
                            $scope.generateUrlOnSuccess(response.data.purpose, response.data.fund_name, orderId, response.data.adviser_username);
                            await analyticsService._push_custom_event_data_to_datalayer('paytm-payment-success-' + response.data.purpose.toLowerCase(), eventData);

                            $scope.hidePageLoader();
                        } else if ($scope.status == 'PENDING' || $scope.status == '') {
                            $scope.paymentStatusLoader = "Checking for payment status";
                            $scope.pollpromise = $scope.paymentPollingStart(15000, async function () {
                                $scope.isValueReturn = false;
                                //get paytm payment status
                                await WdHttpService._get_paytm_payment_status({ 'orderId': orderId })
                                    .then(async response => {
                                        $scope.status = response.result;
                                        if ($scope.status == 'TXN_SUCCESS') {
                                            $scope.thresholdValue = 1;
                                            $scope.isValueReturn = false;
                                            $scope.generateUrlOnSuccess(response.purpose, response.fund_name, orderId, response.adviser_username);
                                        } else if ($scope.status == 'TXN_FAILURE') {
                                            $scope.thresholdValue = 1;
                                            $scope.isValueReturn = false;
                                            await $scope.generateUrlOnFailure(response.purpose, response.fund_name, response.adviser_username);
                                        } else if ($scope.status == 'PENDING' || $scope.status == '') {
                                            $scope.isValueReturn = true;  // set Flag to true to start new call
                                        }
                                        $scope.recordData = response;
                                    }).catch(error => {
                                        console.log(error);
                                        $scope.status = 'TXN_FAILURE';
                                        $scope.hidePageLoader();
                                    });
                            });
                
                        } else {
                            $scope.status = 'TXN_FAILURE';
                            await $scope.generateUrlOnFailure(response.data.purpose, response.data.fund_name, response.data.adviser_username);
                            await analyticsService._push_custom_event_data_to_datalayer('paytm-payment-failed-' + response.data.purpose.toLowerCase(), eventData);
                        }
                        $scope.recordData = response.data;
                    }).catch(error => {
                        console.log(error);
                        $scope.status = 'TXN_FAILURE';
                        $scope.hidePageLoader();
                    });
            } else if (orderId && paymentMode == 'ENACH') {
                await WdHttpService._get_mandate_status({ 'orderId': orderId })
                    .then(async response => {
                        $scope.analystMandateStatus = response.status;
                        var eventData = {
                            'fundName': response.fundName.toLowerCase()
                        };
                        if ($scope.analystMandateStatus == 'REJECTED') {
                            $scope.showPageLoader();
                            $scope.status = 'TXN_FAILURE';
                            await $scope.generateUrlOnFailure(response.purpose, response.fundName, response.adviserUsername);
                            await analyticsService._push_custom_event_data_to_datalayer('enach-payment-failed-' + response.purpose.toLowerCase(), eventData);
                            $scope.hidePageLoader();
                        } else {
                            $scope.status = 'TXN_SUCCESS';
                            var user_profile = await WdHttpService._cognito_profile(false);
                            $scope.brokerName = getProfileValueFor('custom:brokerName1', user_profile);
                            $scope.generateUrlOnSuccess(response.purpose, response.fundName, orderId, response.adviserUsername);
                            await analyticsService._push_custom_event_data_to_datalayer('enach-payment-success-' + response.purpose.toLowerCase(), eventData);
                        }
                    }).catch(error => {
                        console.log(error);
                        $scope.status = 'TXN_FAILURE';
                        $scope.hidePageLoader();
                    });

            } else {
                // fetch fund and check the fee amount - if zero then show success 
                var fundName = sessionService.get('fundName');
                if (fundName) {
                    var data = {
                            q: "fundName:" + fundName,
                            f: "web_admin:" + $scope.webadminName
                        }
                        // Search the fund and get the amount of fee to be paid.
                    await WdHttpService._get_funds(data).then(async function(response) {
                        if (response.status == 200) {
                            var fundDetails = undefined;
                            // This if condition is coded due to a server side bug to be fixed yet.
                            if (response.data.Items.length == 1) {
                                fundDetails = response.data.Items[0];
                            } else if (response.data.Items.length > 1) {
                                response.data.Items.forEach(fund => {
                                    if (fund.fundName == $scope.fundName) {
                                        fundDetails = fund;
                                    }
                                });
                            }

                            if (fundDetails && fundDetails.fee == 0) {
                                $scope.status = 'TXN_SUCCESS';
                                var cognito_profile = await WdHttpService._cognito_profile(false);
                                var brokerName = getProfileValueFor('custom:brokerName1', cognito_profile);
                                $scope.redirectToURL = '/fund-details/' + fundName;
                            } else {
                                // show error pop saying you need to subscribe to this fund.
                                $scope.status = 'TXN_FAILURE';
                                $scope.showErrorPopup('Subscription Fee Payment required. Please try again.');
                            }
                        }
                    });
                } else {
                    // payment failed and show error pop up
                    $scope.status = 'TXN_FAILURE';
                    $scope.showErrorPopup('You will need to try again and pay the subscription fee.');
                }
            }
            $scope.hidePageLoader();
        }

        $scope.paymentPollingStart = function(interval, callback) {
            return $interval(function () {
                if ($scope.isValueReturn) {  //check flag before start new call
                    $scope.paymentStatusLoader = "Checking for payment status";                 
                    callback($scope.isValueReturn);
                }
                $scope.thresholdValue = $scope.thresholdValue - 1;  //Decrease threshold value 
                if ($scope.thresholdValue == 0) {
                    $scope.stopPollingPayment(); // Stop $interval if it reaches to threshold
                }
            }, interval)
        }

        // stop interval for polling
        $scope.stopPollingPayment = function () {
            $interval.cancel($scope.pollpromise);
            $scope.paymentWarningLoader = true;
            $scope.paymentHeaderLoader = 'Payment Status Pending';
            $scope.paymentStatusLoader = "Payment status is still pending for your transaction. Please do not attempt transaction. Payment status will be updated in the next 45 minutes. Kindly check the dashboard after 45 minutes.";
            thresholdValue = 0;     //reset all flags. 
        }
    
        $scope.generateUrlOnSuccess = async function(purpose, fundName = undefined, orderId, adviserUsername) {
            if (purpose == 'RENEWAL' || purpose.includes('ENACH')) {
                $scope.redirectToURL = "/user-fund/" + adviserUsername + "/" + fundName;
            } else {
                $scope.orderExecutionUrl = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + orderId + "&action=order-placement&path=https://" + window.location.hostname + ':' + window.location.port;
            }
        }

        $scope.generateUrlOnFailure = async function(purpose, fundName, adviserUsername) {
            if (purpose == 'ADDITIONALSUBSCRIPTION') {
                $scope.redirectToURL = "/user-fund/" + adviserUsername + "/" + fundName;
            } else if (purpose == 'EQUITYSUBSCRIPTION') {
                $scope.redirectToURL = '/subscribe/' + adviserUsername + '/' + fundName;;
            } else if (purpose == 'RENEWAL' || purpose.includes('ENACH')) {
                $scope.redirectToURL = "/fund-revision?tab=payment";
            }
        }

    }
]);